<script>
// @ is an alias to /src
// import AppHeader from '@/components/AppHeader.vue'

export default {
  name: "Maintenance",
  components: {
    // AppHeader
  },
  methods: {
    checkLogin() {
      this.$store.dispatch("auth/checkLogin")
    },
  },
}
</script>

<template>
  <div id="Maintenance" class="gContainer page">
    <b-alert variant="warning" show>Application is currently unavailable due to maintenance. Please check back later.</b-alert>
  </div>
</template>

<style>
#Maintenance {
  background-color: #f1f5fb;
  height: 100%;
  margin-left: 0px;
  padding-left: 0px;
  font-size: 14pt;
  border: 1px solid #979797;

  text-align: center;
  color: #000;
  font-weight: bold;
}
</style>
